import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IGroup } from '../../../userManagement/groups/serverApi/types/IGroup';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { IDataAlert } from '../types/IDataAlert';

export interface IGetDataAlertsResult extends IGetItemsResult {
  dataAlerts: IDataAlert[];
  users: IUser[];
  groups: IGroup[];
}

export class GetDataAlertsRequest extends Request<IGetItemsParams, IGetDataAlertsResult> {
  constructor(params: IGetItemsParams) {
    super('getDataAlerts', params);
  }
}
